import { notification } from 'antd'
import i18next from 'i18next'
import { action, makeObservable } from 'mobx'

import { IRootStore } from 'store/types'
import { BaseStore } from 'shared/stores/BaseStore'

import { ticketApi } from '../../api'
import { TicketKeys } from '../../data'
import { GetTicketListRequest } from '../../types'
import { Ticket } from './Ticket'

const getKey = (key: string) => `${TicketKeys.ticketModule}.${key}`

export class TicketStore extends BaseStore<Ticket> {
  constructor(private readonly rootStore: IRootStore) {
    super()
    makeObservable(this)
  }

  @action
  setTicketList = async (value: Ticket[]) => {
    this.putEntities(value)
  }

  @action
  async loadList(disableLoading: boolean = false, data: GetTicketListRequest) {
    try {
      if (!disableLoading) {
        this.setLoading(true)
      }

      const res = await ticketApi.getTicketList({
        ...data,
      })

      const tickets = res.data.map((ticket) => Ticket.create(ticket))

      this.setTicketList(tickets)
      this.setTotalCount(res.total)
    } catch (error) {
      notification.error({
        message: i18next.t(getKey('getTicketListError')),
        description: (error as Error).message,
      })
    } finally {
      this.setLoading(false)
    }
  }
}
